module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-10 widgets"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.widgets) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('h2', [_vm._v("Agents: Current Status")])]), _vm._v(" "), _c('div', {
    staticClass: "widgets-grid"
  }, _vm._l((_vm.widgets), function(widget) {
    return _c('dashboard-widget', {
      key: widget.key,
      attrs: {
        "widget": widget
      }
    })
  }), 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.tableData) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Agents")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('records-table', {
    attrs: {
      "tableData": _vm.tableData,
      "searchContext": _vm.searchContext
    },
    on: {
      "search": _vm.tableSearch,
      "download": _vm.download,
      "showRecord": _vm.showRecord
    }
  })], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters),
      expression: "filters"
    }],
    staticClass: "col-xs-12 col-md-3 col-lg-2"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters,
      "renderSearch": false
    },
    on: {
      "applyFilters": _vm.applyFilters
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(!_vm.loaded) ? _c('loading-modal') : _vm._e(), _vm._v(" "), _c('agent-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentId),
      expression: "agentId"
    }],
    attrs: {
      "agentId": _vm.agentId
    },
    on: {
      "close": _vm.closeAgentModal
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a4eb49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/AgentAnalytics.vue
// module id = 628
// module chunks = 0